import { ArrowRightLeft, Bot, FolderOpen, KeyRound, Landmark, LineChart, Megaphone, ScrollText, Users, UserX, Zap } from 'lucide-react';

// Presentation only: these helpers never add routes or alter module permissions.
export function navigationTone(path = '') {
  if (/tests|ranking|notification/.test(path)) return 'amber';
  if (/reseller|credit-packs|partner-apps/.test(path)) return 'violet';
  if (/sales|financeir|buy-credits|postpaid|connections|chats|live-clients/.test(path)) return 'green';
  if (/servers|catalog|categories|permissions|api-integrations/.test(path)) return 'cyan';
  return 'blue';
}

export function navigationContext(modules, pathname) {
  for (const group of modules || []) {
    const item = (group.items || []).find(entry => pathname === entry.path || pathname?.startsWith(`${entry.path}/`));
    if (item) return { section: group.label, icon: item.icon, tone: navigationTone(item.path) };
  }
  return { section: '', icon: null, tone: 'blue' };
}

// Complete the private menu from links already filtered by the existing permissions/hub policy.
// This map only chooses a section and icon; it never supplies or grants a destination.
const TOOL_PRESENTATION = {
  '/contacts': { group: 'crm', icon: Users },
  '/funnel': { group: 'crm', icon: LineChart },
  '/aurax-ai': { group: 'crm', icon: Bot },
  '/triggers/chatbot': { group: 'crm', icon: Bot },
  '/triggers': { group: 'crm', icon: Zap },
  '/recuperacao': { group: 'crm', icon: Megaphone },
  '/admin/materiais': { group: 'crm', icon: FolderOpen },
  '/gestor-xui/gateway': { group: 'creditos', icon: Landmark },
  '/gestor-xui/credit-logs': { group: 'creditos', icon: ScrollText },
  '/gestor-xui/credential-generation': { group: 'config', icon: KeyRound },
  '/gestor-xui/inactive-clients': { group: 'gestao', icon: UserX },
  '/gestor-xui/inactive-resellers': { group: 'gestao', icon: UserX },
  '/gestor-xui/reseller-migration': { group: 'gestao', icon: ArrowRightLeft },
};

export function completeOfficeNavigation(modules = [], paletteModules = []) {
  const groups = modules.map(group => ({ ...group, items: [...(group.items || [])] }));
  const byId = new Map(groups.map(group => [group.id, group]));
  const seen = new Set(groups.flatMap(group => group.items.map(item => item.path)));
  for (const tools of paletteModules.filter(group => group.id === 'ferramentas')) {
    for (const item of tools.items || []) {
      if (!item.path || seen.has(item.path)) continue;
      const presentation = TOOL_PRESENTATION[item.path];
      let group = byId.get(presentation?.group);
      if (!group) {
        group = byId.get('ferramentas');
        if (!group) {
          group = { ...tools, items: [], defaultPath: item.path };
          groups.push(group);
          byId.set(group.id, group);
        }
      }
      group.items.push({ ...item, icon: presentation?.icon || item.icon });
      seen.add(item.path);
    }
  }
  return groups.filter(group => group.items.length);
}
